import { render, staticRenderFns } from "./supplyOrderDetail.vue?vue&type=template&id=2bbe4904&scoped=true"
import script from "./supplyOrderDetail.vue?vue&type=script&lang=js"
export * from "./supplyOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./supplyOrderDetail.vue?vue&type=style&index=0&id=2bbe4904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe4904",
  null
  
)

export default component.exports